export const UNFURLED_LINK_METADATA_VERSION = 'article-description-v1';
